import PropTypes from 'prop-types';

import Box, { BoxProps as BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Container, Stack, Typography } from '@mui/material';
import useAppMediaQuery from '@classity-edtech/ui-base/dist/hooks/useMediaQuery';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { Button } from '@classity-edtech/ui-base';
import { useConfig } from '../../../contexts';
import { Link } from 'react-router-dom';

export interface JoinUsProps extends BoxProps {
  title: string;
  description: string;
  ctaLabel: string;
}

export const JoinUs = ({ className, ...props }: JoinUsProps) => {
  const screens = useAppMediaQuery();
  const smallScreens = screens.isMobile || screens.isTablet;
  const { learnUi } = useConfig() as any;
  const learnUiUrl = learnUi?.url;

  return (
    <Box
      className={className}
      sx={{
        background: globalColours['$global-colour-palette-gray-50'],
      }}
    >
      <Container
        sx={{
          display: 'flex',
          py: 9,
          alignItems: 'center',
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            px: 0.5,
            gap: 1,
            textAlign: 'center',
            mx: 'auto',
          }}
        >
          <Typography
            variant={smallScreens ? 'subtitle2' : 'subtitle1'}
            sx={{ maxWidth: '515px' }}
            variantMapping={{ subtitle1: 'h2', subtitle2: 'h2' }}
          >
            {props?.title}
          </Typography>
          <Typography
            variant={screens.isDesktop ? 'body2SemiBold' : 'body3SemiBold'}
            sx={{ maxWidth: '500px' }}
          >
            {props?.description}
          </Typography>
          <Link
            to={`${learnUiUrl}/teach/signup`}
            onClick={() => {}}
            style={{ textDecoration: 'none', width: 'fit-content' }}
          >
            <Button size={'large'} disableBottomFixed data-testid='homepage-enrolment-button'>
              <Typography variant='body2SemiBold'>{props?.ctaLabel}</Typography>
            </Button>
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};

JoinUs.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
};

JoinUs.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(JoinUs)(
  ({ theme }) => `
  & .blinker {
    animation: blinker 1s linear infinite;

    @keyframes blinker {
      50% {
        opacity: 0.6;
      }
    }
  }
`,
);
